import React from "react";

import { Icon } from "components/Icon";

import {
    formHttpIpModel,
    applyValidationErrors,
    removeByIndex,
} from "./TrunkFormRefactored.utils";
import {
    Header,
    StyledGrid,
    StyledList,
    StyledListItem,
    StyledStatusIndexContainer,
    AddNewButton,
} from "./TrunkFormRefactored.styles";

import { Form } from "rsuite";

const IpWhiteListSection = ({
    isMobile,
    httpIpList,
    setHttpIpList,
    setError,
}) => {
    return <>
        <Header>IP White List</Header>

        <StyledGrid
            isMobile={isMobile}
            style={{ margin: 0, marginLeft: 30 }}
            showBorder={httpIpList.length > 3}
            className="list-container"
        >
            <StyledList>
                {httpIpList.map((httpIp, idx) => {
                    return <StyledListItem>
                        <Form
                            model={formHttpIpModel}
                            onChange={(value) => {

                                const checkedFormValue = formHttpIpModel.check(value);

                                applyValidationErrors(setError, "ipHttpErrors", idx, checkedFormValue);
                            }}
                            formDefaultValue={{
                                ip: httpIp
                            }}
                        >
                            <Form.Group>
                                <StyledStatusIndexContainer width={36}>
                                    <span className="index">{idx + 1}</span>
                                </StyledStatusIndexContainer>
                                <Form.Control
                                    name="ip"
                                    placeholder="0.0.0.0"
                                    style={{ width: 165 }}
                                    onChange={(value) => {
                                        setHttpIpList(prev => {
                                            const currentHttpIpList = prev.map(x => x);
                                            const head = currentHttpIpList.slice(0, idx);
                                            const tail = currentHttpIpList.slice(idx + 1, currentHttpIpList.length);

                                            return [...head, value, ...tail];
                                        });
                                    }}
                                />
                            </Form.Group>
                            <Icon
                                onClick={() => {
                                    const newList = removeByIndex(httpIpList, idx);

                                    setHttpIpList(newList);
                                }}
                                className="delete"
                                icon="trash"
                            />
                        </Form>
                    </StyledListItem>;
                })}
                <AddNewButton
                    ml={36}
                    appearance="ghost"
                    onClick={() => {
                        const newList = httpIpList.map((x) => x);
                        newList.push("");
                        setHttpIpList(newList);
                    }}
                >
                    <Icon icon="plus" /> Add new{httpIpList && !httpIpList.length ? " http" : ""}
                </AddNewButton>
            </StyledList>
        </StyledGrid>
    </>;
};

export default IpWhiteListSection;
